import React, { FunctionComponent } from 'react'
import EasySoftwareEditorContainer from 'Root/Shared/components/EasySoftwareEditorContainer/EasySoftwareEditorContainer'
import {
  PuxWysiwygHtmlBodyType,
} from 'Shared/components/PuxWysiwyg/PuxWysiwyg'

import PuxButton, { PuxButtonType } from '../PuxButton/PuxButton'
import PuxVideo, { PuxVideoType } from '../PuxVideo/PuxVideo'

export interface EasySoftwareHeroBannerItemVideoType {
  contentItemId: string
  contentType: string
  displayText: string
  heroBannerItemVideoContent: PuxWysiwygHtmlBodyType
  heroBannerItemVideoButton1: PuxButtonType
  heroBannerItemVideoButton2: PuxButtonType
  puxVideo: PuxVideoType
}

export interface EasySoftwareHeroBannerItemVideoProps {
  data: EasySoftwareHeroBannerItemVideoType
  editorPath: string
  pageContentItemId: string
}

const EasySoftwareHeroBannerItemVideo: FunctionComponent<EasySoftwareHeroBannerItemVideoProps> = (
  props
) => {
  const primaryButton = props.data.heroBannerItemVideoButton1,
    secondaryButton = props.data.heroBannerItemVideoButton2,
    hasPrimaryButton = Boolean(primaryButton?.buttonLink.text?.[0]),
    hasSecondaryButton = Boolean(secondaryButton?.buttonLink.text?.[0]),
    classes = [`HeroBannerItem`]

  return (
    <div className={classes.join(` `)}>
      <div className='HeroBannerItem-image'>
        {props.data.puxVideo?.videoYTID?.html && (
          <PuxVideo
            videoStructuredDataContentUrl={
              props.data.puxVideo?.videoStructuredDataContentUrl
            }
            videoStructuredDataDescription={
              props.data.puxVideo?.videoStructuredDataDescription
            }
            videoStructuredDataName={
              props.data.puxVideo?.videoStructuredDataName
            }
            videoStructuredDataUploadDate={
              props.data.puxVideo?.videoStructuredDataUploadDate
            }
            videoThumbnail={props.data.puxVideo?.videoThumbnail}
            videoYTID={props.data.puxVideo?.videoYTID}
          />
        )}
      </div>
      <div className='HeroBannerItem-text'>
        <EasySoftwareEditorContainer pageContentItemId={props.pageContentItemId} content={props.data.heroBannerItemVideoContent} editorPath={props.editorPath} wysiwygId={props.data.contentItemId} />
        {(hasPrimaryButton || hasSecondaryButton) && (
          <div className='HeroBannerItem-buttons'>
            {hasPrimaryButton && <PuxButton {...primaryButton} />}
            {hasSecondaryButton && <PuxButton {...secondaryButton} />}
          </div>
        )}
      </div>
    </div>
  )
}

export default EasySoftwareHeroBannerItemVideo
